import React, { useState } from "react";
import { Line, Pie, Chart, HorizontalBar } from "react-chartjs-2";
import { chartColors } from "../../components/form/debtPayOff/components/color";
import "./mainDashboard.css";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import { Progress } from "antd";
import restIcon from "../../assets/images/budget/rest.svg";
import calanderIcon from "../../assets/images/budget/calander.png";
import { DatePicker } from "antd";
import { Select } from "antd";
import moment from "moment";
import { useTheme } from "../../utils/ThemeContext";
import { MODULE_API } from "../../apis";
const { Option } = Select;

export const BudgetExpanse = ({ loading, data, getAllBudgets }) => {
  const { theme } = useTheme();

  const [compareFilter, setCompareFilter] = useState("Today");
  const [currentMonthTopExpanse, setCurrentMonthTopExpanse] = useState([]);
  const [currentYearTopExpanse, setCurrentYearTopExpanse] = useState([]);
  const [isloading, setIsLoading] = useState(false);

  const { MonthPicker } = DatePicker;

  const monthsFilter = [
    {
      id: 1,
      filter: "Today",
    },
    {
      id: 2,
      filter: "Compare Last Month",
    },
    {
      id: 2,
      filter: "Compare Last Year",
    },
  ];

  const tags = [
    "Current Month",
    "This month to last month",
    "This year to last year",
    "This Month to last year",
  ];
  const getBudgets = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      let data = await MODULE_API.getFilterBudgets(startDate, endDate);
      if (data && data.data) {
        return data.data;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const filterData = async (selectedFilter) => {
    let startDate, endDate;

    // Get current date
    const date = moment();
    console.log("selectedFilter", selectedFilter);
    switch (selectedFilter) {
      case "Current Month":
      case "This Month":
        startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the current month
        endDate = date.endOf("month").format("YYYY-MM-DD"); // End of the current month
        break;
      case "This month to last month":
        startDate = date
          .clone()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of last month
        endDate = date.endOf("month").format("YYYY-MM-DD"); // End of this month
        break;
      case "Compare Last Month":
        startDate = date
          .clone()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of last month
        endDate = date
          .clone()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD"); // End of last month
        break;

      case "This year to last year":
        startDate = date
          .clone()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD"); // Start of last year
        endDate = date.endOf("year").format("YYYY-MM-DD"); // End of this year
        break;
      case "Compare Last Year":
        startDate = date
          .clone()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD");
        endDate = date.endOf("year").subtract(1, "year").format("YYYY-MM-DD");
        break;

      case "This Month to last year":
        startDate = date
          .clone()
          .subtract(1, "year")
          .startOf("month")
          .format("YYYY-MM-DD"); // Start of the same month last year
        endDate = date
          .clone()
          .subtract(1, "year")
          .endOf("month")
          .format("YYYY-MM-DD"); // End of the same month last year
        break;

      default:
        startDate = date.startOf("month").format("YYYY-MM-DD");
        endDate = date.endOf("month").format("YYYY-MM-DD");
    }

    // console.log("filterData", startDate, endDate);
    getAllBudgets(startDate, endDate);

    if (selectedFilter == "Compare Last Month") {
      let currentMonthStartDate = date.startOf("month").format("YYYY-MM-DD");
      let currentMonthEndDate = date.endOf("month").format("YYYY-MM-DD");

      let response = await getBudgets(
        currentMonthStartDate,
        currentMonthEndDate
      );
      setCurrentMonthTopExpanse(response);
    } else if (selectedFilter == "Compare Last Year") {
      const currentDate = moment();
      let currentYearStartDate = currentDate
        .clone()
        .startOf("year")
        .format("YYYY-MM-DD");
      let currentYearEndDate = currentDate
        .clone()
        .endOf("year")
        .format("YYYY-MM-DD");

      let response = await getBudgets(currentYearStartDate, currentYearEndDate);
      setCurrentYearTopExpanse(response);
    }
  };

  const currentMonth = moment().format("MMM YYYY");
  const lastMonth = moment().subtract(1, "months").format("MMM YYYY");
  const currentYear = moment().format("YYYY");
  const lastYear = moment().subtract(1, "years").format("YYYY");

  const options = {
    plugins: {
      // datalabels: {
      //   display: true,
      //   color: "white",
      //   formatter: (value, context) => `${value}%`,
      // },
      datalabels: {
      display: false, // We’ll handle the text rendering manually
    },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true, // Ensure bars are stacked on the x-axis (horizontal stacking)
          gridLines: {
            color: "rgba(0, 0, 0, 0)", // Make grid lines invisible
          },
          ticks: {
            callback: function (value) {
              // Format the ticks on the x-axis as currency
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
          },
        },
      ],
      yAxes: [
        {
          stacked: true, // Stack bars vertically
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          let label =
            (data.datasets[tooltipItem.datasetIndex].labels &&
              data.datasets[tooltipItem.datasetIndex].labels[
                tooltipItem.index
              ]) ||
            data.datasets[tooltipItem.datasetIndex].label ||
            data.labels[tooltipItem.index] ||
            "";
          if (label) {
            label += ": ";
          }
          let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

          label +=
           `${parseFloat(value).toFixed(2)}` + 
            (data.datasets[tooltipItem.datasetIndex].labelSuffix || "");
          return label;
        },
      },
    },
    animation: {
      onComplete: function () {
        const chart = this.chart;
        const ctx = chart.ctx;
        const datasets = chart.data.datasets;
        datasets.forEach((dataset, index) => {
          ctx.fillStyle = "white"; // Text color
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";

          dataset.data.forEach((value, i) => {
            const x = chart.getDatasetMeta(index).data[i]._model.x;
            const y = chart.getDatasetMeta(index).data[i]._model.y;
            const width = chart.getDatasetMeta(index).data[i]._model.width;
            const height = chart.getDatasetMeta(index).data[i]._model.height;

            // Drawing the value on top of each bar
            ctx.fillText(
              value.toFixed(2), // Value to display
              x + width / 2, // X position (center of the bar)
              y + height / 2 // Y position (center of the bar)
            );
          });
        });
      },
    },
  };
  const labels =
    data &&
    data.map((item) => {
      const maxLength = 20; // Set your desired max length here
      const itemName = item.category_name || "Unknown Item";
      const subcategoryName = item.name ? ` (${item.name})` : ""; 
  
      // Concatenate category and subcategory names
      const fullLabel = `${itemName}${subcategoryName}`;
  
      return fullLabel.length > maxLength
        ? `${fullLabel.slice(0, maxLength)}...`
        : fullLabel;
    });
  const amounts = data && data.map((item) => item.trans_amount || 0);
  const dataSet2Amount =
    compareFilter === "Compare Last Month"
      ? currentMonthTopExpanse
      : compareFilter === "Compare Last Year"
      ? currentYearTopExpanse
      : [];
  const amountsDataSet2 = (dataSet2Amount || []).map(
    (item) => item.trans_amount || 0
  );

  console.log("amounts", amounts, amountsDataSet2);
  const chartDataCompare = {
    labels: labels ? labels : [],
    datasets: [
      {
        label:
          compareFilter === "Compare Last Month" ? currentMonth : currentYear,
        data: amountsDataSet2 ? amountsDataSet2 : [],
        backgroundColor: "#2A3DA3",
      },
      {
        label: compareFilter === "Compare Last Month" ? lastMonth : lastYear,
        data: amounts ? amounts : [],
        backgroundColor: "#00f710",
      },
    ],
  };

  return (
    <React.Fragment>
      {" "}
      <div
        className="budgetMaincards"
        style={{
          width: "100%",
          padding: "0px",
          borderRadius: "0px",
          position: "relative",
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
      >
        <div className="filterWithName">
          <h1
            className="budgetCardheading"
            style={{
              color: theme === "light" ? "#232323" : "#ffffff",
            }}
          >
            Budgets
          </h1>
          <div className="compareSelectContainer">
            {/* <div className="filterIcons">
              <Select
                suffixIcon={
                  <img
                    src={calanderIcon}
                    height={16}
                    width={17}
                    alt="icon"></img>
                }
                showSearch
                style={{ width: 170, outline: "none", border: "none" }}
                placeholder="Compare"
                onChange={(value, id) => {
                  console.log("value", value);
                  filterData(value);
                }}>
                {tags &&
                  tags.map((item, index) => (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  ))}
              </Select>
            </div> */}
            <div className="compareSelect">
              {monthsFilter &&
                monthsFilter.map((item, index) => (
                  <div
                    key={index}
                    className={
                      item.filter === compareFilter
                        ? "selectedfilter"
                        : "unSelectedfilter"
                    }
                    onClick={() => {
                      setCompareFilter(item.filter);
                      filterData(item.filter);
                    }}
                  >
                    {item.filter}
                  </div>
                ))}
            </div>
            {/* <img style={{ cursor: "pointer" }} src={restIcon} alt="reset" /> */}
          </div>
        </div>
        {compareFilter === "Today" ? (
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              flexDirection: "column",
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            {data && data.length > 0 ? (
              data.map((item, index) => {
                const compareData =
                  compareFilter === "Compare Last Month"
                    ? currentMonthTopExpanse
                    : compareFilter === "Compare Last Year"
                    ? currentYearTopExpanse
                    : [];

                // Find matching category in the compareData
                const matchingCategory =
                  compareData &&
                  compareData.find(
                    (compareItem) =>
                      compareItem.category_name === item.category_name
                  );
                return (
                  <div
                    key={index}
                    className=""
                    style={{
                      gap: "1rem",
                      marginTop: "8px",
                      color: theme === "dark" && "white",
                    }}
                  >
                    <span
                      className="budgetCardTitle"
                      style={{ color: theme === "light" ? "#232323" : "white" }}
                    >
                      {item.category_name && item.category_name}{" "} {item.name && `(${item.name})`}
                      {compareFilter === "Today"
                        ? "(" +
                          (item.trans_amount
                            ? "$" +
                              item.trans_amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "$" + (0).toFixed(2)) +
                          " of " +
                          (item.totalBudget
                            ? "$" +
                              item.totalBudget
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "$" + (0).toFixed(2)) +
                          ")"
                        : null}
                    </span>
                    {compareFilter === "Today" ? (
                      <span
                        style={{
                          float: "right",
                          color: theme === "dark" && "white",
                        }}
                      >
                        $
                        {item.totalBudget !== undefined
                          ? `${Math.abs(
                              item.totalBudget -
                                (item.trans_amount ? item.trans_amount : 0)
                            )
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                          : "$" + (0).toFixed(2)}{" "}
                        {item.trans_amount > item.totalBudget ? "Over" : "Left"}
                      </span>
                    ) : null}
                    <div className="progress-container-budget">
                      <div
                        className="progress-bar-budget"
                        style={{
                          lineHeight: "16px",
                          width:
                            matchingCategory &&
                            (matchingCategory.totalBudget ||
                              matchingCategory.trans_amount)
                              ? `${
                                  ((matchingCategory &&
                                  matchingCategory.trans_amount
                                    ? matchingCategory &&
                                      (matchingCategory.trans_amount || 0)
                                    : 0) /
                                    (matchingCategory &&
                                      matchingCategory.totalBudget)) *
                                  100
                                }%`
                              : "0%", // Default to 0% if totalAmount or usedAmount is missing
                          background:
                            matchingCategory &&
                            matchingCategory.trans_amount &&
                            ((matchingCategory.trans_amount || 0) /
                              matchingCategory.totalBudget) *
                              100 >
                              100 &&
                            "red",
                        }}
                      >
                        {compareFilter !== "Today" &&
                          matchingCategory &&
                          matchingCategory.trans_amount &&
                          ((matchingCategory.trans_amount || 0) /
                            matchingCategory.totalBudget) *
                            100 >
                            30 &&
                          matchingCategory &&
                          matchingCategory.trans_amount &&
                          matchingCategory.trans_amount !== undefined &&
                          `$${matchingCategory.trans_amount
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                      </div>
                      <div
                        className="progress-bar-budget2"
                        style={{
                          lineHeight: "16px",
                          background:
                            item && item.totalBudget
                              ? ((item.trans_amount || 0) / item.totalBudget) *
                                  100 >
                                50
                                ? `linear-gradient(
                                  90deg,
                                  #00f710 ${
                                      (item.trans_amount || 0) / item.totalBudget < 0
                                    ? Math.min(Math.abs(((item.trans_amount || 0) / item.totalBudget) * 100) + 100, 100) // Add 100 if negative
                                    : 110 - Math.min(Math.abs(((item.trans_amount || 0) / item.totalBudget) * 100), 100) // Subtract 100 if positive
                                  }%,
                                  #ff3939 
                                  ${
                                  Math.min(Math.abs(((item.trans_amount || 0) / item.totalBudget) * 100), 100)
                                    // ((item.trans_amount || 0) /
                                    //   item.totalBudget) *
                                    // 100
                                  }%
                                )`
                                : `linear-gradient(
                                  90deg,
                                  #00f710 ${
                                    ((item.trans_amount || 0) /
                                      item.totalBudget) *
                                    100
                                  }%,
                                  #00f710 100%
                                )`
                              : "#00f710",
                          width:
                            item && item.totalBudget
                              ? `${
                                  ((item.trans_amount ? item.trans_amount : 0) /
                                    item.totalBudget) *
                                  100
                                }%`
                              : "0%", // Default to 0% if totalAmount or usedAmount is missing
                        }}
                      >
                        {compareFilter !== "Today" &&
                          item &&
                          item.totalBudget &&
                          ((item.trans_amount || 0) / item.totalBudget) * 100 >
                            30 &&
                          `$${(item && (item.trans_amount || item.totalBudget)
                            ? item.totalBudget - (item.trans_amount || 0)
                            : 0
                          )
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                      </div>
                      <div className="progress-bar-value-budget"></div>
                    </div>
                  </div>
                );
              })
            ) : (
              <span
                style={{
                  color: theme === "light" ? "#232323" : "#ffffff",
                }}
                className="noDataToShow"
              >
                No Budget To Show
              </span>
            )}
          </div>
        ) : (
          <div style={{ height: "300px", display: "flex" }}>
            <HorizontalBar options={options} data={chartDataCompare} />
          </div>
        )}
        <NewLoader isLoading={loading} />
        {/*compareFilter !== "Today" && (
          <div className="progress-legends">
            <div className="progress-legend-conatiner">
              <div className="progress-legend-previous"></div>{" "}
              <span>
                {compareFilter === "Compare Last Month"
                  ? currentMonth
                  : currentYear}
              </span>
            </div>
            <div className="progress-legend-conatiner">
              <div className="progress-legend-current"></div>
              <span>
                {compareFilter === "Compare Last Month" ? lastMonth : lastYear}{" "}
              </span>
            </div>
          </div>
        )*/}
      </div>
    </React.Fragment>
  );
};
